import React from 'react';
import PropTypes from 'prop-types';

//#region COMPONENTS
import ContentOverview from '../../../ContentOverview';
//#endregion

import './styles.scss';

function EPGProgramDetails({
  content
}) {
  return (
    <div className="epg-program-details">
      <ContentOverview content={content} />
    </div>
  )
};

EPGProgramDetails.propTypes = {
  content: PropTypes.shape({
    country: PropTypes.string,
    description: PropTypes.string
  }).isRequired
};

export default React.memo(EPGProgramDetails);
